<template>
    <div class="page_menu_main flex-col" :class="{ 'show': isVisible, 'hide': isHiding }">
        <div class="box_1 flex-row">
            <img
                    class="image_go_back"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/mobile_menu_bj03.png"
            />
            <div class="group_1 flex-col"></div>
            <div class="text-wrapper_1 flex-col">
                <span class="text_company">北京康柏汉森医药科技咨询有限责任公司</span>
                <span class="text_company_en">Beijing&nbsp;Comprehensive&nbsp;Pharmaceutical&nbsp;Consulting&nbsp;Co.,Ltd.</span>
            </div>
            <img
                    class="menu_close"
                    @click="closeMenu"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/mobile_menu_bj04.png"
            />
        </div>
        <div class="box_2 flex-col">
            <div class="list_1 flex-col">
                <div
                        class="list-items_1 flex-row justify-between"
                        v-for="(item, index) in mainMenu"
                        @click="handleMenu(item)"
                        :key="index"
                >
                    <span :class="activeIndex==item.id ? 'text_menu_name_select':'text_menu_name' " v-html="item.label"></span>
                    <img class="image_2" referrerpolicy="no-referrer" src="../../assets/header/mobile_menu_arr.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            defaultActiveIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                activeIndex: this.defaultActiveIndex,
                isVisible: false,
                isHiding: true,
                mainMenu: [
                    {
                        id:0,
                        bj:'#ffffff',
                        label: '首页',
                        href:'home',
                        menuClass:'nav1',
                        subItems: [],
                        lanhuimage0: '',
                    },
                    {
                        id:1,
                        bj:'#ffffff',
                        label: '走进康柏',
                        href:'about',
                        menuClass:'nav2',
                        subItems: [
                            { label: '关于我们', href: 'about#introduce-section2' },
                            { label: '企业荣誉', href: 'about#honor-section2' },
                            { label: '行业价值', href: 'about#value-section2' },
                            { label: '服务优势', href: 'about#server-section2' },
                        ],
                        lanhuimage0:'',
                    },
                    {
                        id:2,
                        bj:'#ffffff',
                        label: '核心业务',
                        href:'Advisory',
                        menuClass:'nav3',
                        subItems: [
                            { label: '渠道风控管理', href: 'Advisory' },
                            { label: '业务合规管理', href: 'compliance' },
                            { label: '企业健康咨询', href: 'consultation' },
                        ],
                        lanhuimage0: '',
                    },
                    {
                        id:3,
                        bj:'#ffffff',
                        label: '新闻中心',
                        href:'Information',
                        menuClass:'nav4',
                        subItems: [
                            { label: '康柏动态', href: 'dynamics' },
                            { label: '行业观察', href: 'observation' },
                        ],
                        lanhuimage0: '',
                    },
                    {
                        id:4,
                        bj:'#ffffff',
                        label: '关于我们',
                        href:'contact',
                        menuClass:'nav5',
                        subItems: [
                            { label: '联系我们', href: 'contact' },
                            { label: '加入我们', href: 'join' },
                        ],
                        lanhuimage0: '',
                    }
                ],
                constants: {}
            };
        },
        mounted() {
            setTimeout(() => {
                this.isVisible = true;
            }, 20);
        },
        watch: {
            defaultActiveIndex(newVal) {
                this.activeIndex = newVal;
            }
        },
        methods: {
            handleMenu(item){
                let that = this;
                let data = this.mainMenu;
                for(let i=0;i< data.length;i++){
                    if(item.id === data[i].id){
                        let subItem = data[i].subItems;
                        if(subItem && subItem.length>0){
                            this.$emit('selectMenu',item);
                        }else{
                            this.closeMenu();
                            this.goto(item.href);
                        }
                    }
                }
            },
            closeMenu() {
                this.isHiding = true;
                this.isVisible = false;
                // 动画结束后触发关闭事件
                setTimeout(() => {
                    this.$emit('close');
                }, 300); // 这个时间需要与CSS中的transition时间一致
            },
            open() {
                this.isHiding = false;
                this.isVisible = true;
            },
            // 辅助方法，用于滚动到指定的锚点
            scrollToAnchor(anchor) {
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    let check = url.split('#')[0];
                    if (this.$route.path === check){
                        this.scrollToAnchor(url.split('#')[1]);
                    }else{
                        this.$router.push(url).then(() => {
                            this.scrollToAnchor(url.split('#')[1]);
                        });
                    }
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },

        }
    };
</script>
<style scoped lang="css" >
    .page_menu_main {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 99999 !important;
        overflow: hidden;
        transform: translateX(-100%);
        transition: transform 0.3s ease-out;
        background-color: white;
    }
    .page_menu_main.show {
        transform: translateX(0);
    }
    .page_menu_main.hide {
        transform: translateX(-100%);
    }

    .box_1 {
        background: url(../../assets/header/mobile_menu_bj01.png)
        100% no-repeat;
        background-size: 100% 100%;
        padding: 21px 28px 23px 30px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_go_back {
        width: 117px;
        height: 46px;
    }

    .group_1 {
        background-color: rgba(0, 153, 145, 0.35);
        width: 1px;
        height: 27px;
        margin: 10px 0 9px 10px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text-wrapper_1 {
        margin: 4px 0 1px 2px;
    }

    .text_company {
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 17px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 19px;
        margin-right: 12px;
    }

    .text_company_en {
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 11px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        text-align: left;
        white-space: nowrap;
        line-height: 19px;
        margin-top: 1px;
    }

    .menu_close {
        position: absolute;
        right: 20px;
        cursor: pointer;
        width: 36px;
        height: 36px;
        margin: 5px 0 5px auto;
    }

    .box_2 {
        background-color: white;
    }

    .list_1 {
        cursor: pointer;
    }

    .list-items_1 {
        width: 100%;
        background: #FFFFFF;
        box-shadow: inset 0px -1px 0px 0px #E8E8E8;
        padding: 20px 25px 20px 40px;
    }
    .justify-between
    {
        display: flex;
        justify-content: space-between;
    }
    .flex-row {
         display: flex;
         flex-direction: row;
     }

    .text_menu_name {
        width: 112px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 400;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_menu_name_select {
        width: 112px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .image_2 {
        position: absolute;
        right: 40px;
        width: 10px;
        height: 21px;
        /*border: 1.5px solid rgba(222, 222, 222, 1);*/
        margin: 9px 0 10px auto;
    }

    @media (max-width: 680px) {

        .image_go_back {
            width: 90px;
            height: 35px;
        }
        .text_company {
            font-size: 10px;
            line-height: 14px;
            margin-right: 5px;
        }
        .text_company_en {
            font-size: 6px;
            line-height: 10px;
        }
        .box_1 {
            padding: 14px 28px 0px 10px;
        }
        .menu_close {
            cursor: pointer;
            width: 20px;
            height: 20px;
            margin: 5px 0 5px auto;
        }

        .list-items_1 {
            padding: 12px 10px 12px 25px;
        }

        .text_menu_name, .text_menu_name_select {
            font-size: 20px;
            line-height: 30px;
        }
        .image_2 {
            right: 20px;
            margin: 5px 0 10px auto;
        }
    }

</style>
